import useScripts from "hooks/use-scripts";
import useSession from "hooks/use-session";
import Dropdown from "react-bootstrap/esm/Dropdown";
import DropdownButton from "react-bootstrap/esm/DropdownButton";
import { useRouting } from "../../hooks/with-routing";
import { LinkRouting } from "../buttons/buttons";
import "./header.scss";

const Header = () => {
	const name = useSession.use.name();
	const signout = useSession.use.signout();
	const { scriptResources } = useSession.use.eCommerceConfiguration();
	const createPath = useRouting.use.createPath();
	const imageUrl = createPath("/Usuarios/Configuracion/:segmento/Logo");

	useScripts(scriptResources);

	const cerrarSesion = () => {
		signout();
	};

	return (
		<nav className="navbarComercios navbar-expand-lg navbar-light" >
			<div className="container-fluid banner-comercio">
				<img src={imageUrl} className=" float-start" alt="alt" height="45" />
				<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="MenuSalir" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="Menusalir">
					<DropdownButton title={name} className="ms-auto mb-2 mb-lg-0 dropdown-Comercio" style={{ display: "inline-block" }}>
						<Dropdown.Item as={LinkRouting} to="/:segmento/cambiar-clave"><span>Cambiar contrase&ntilde;a</span></Dropdown.Item>
						<Dropdown.Item onClick={cerrarSesion}>Salir</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>
		</nav>
	);
};

export default Header;